import {
  Box,
  Typography,
} from '@mui/material';
import {styled} from '@mui/system';

export const IconContainer = styled('span')(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '.5rem',
}));

export const ApptHeader = styled(Box)(({theme}) => ({
  width: '100%',
  minWidth: '300px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const TypographyH3 = styled(Typography)(({theme}) => ({
  color: theme.palette.text.primary,
  fontWeight: '500',
  fontSize: '1.25rem',
  lineHeight: '1.5',
}));

export const TypographyBody2 = styled(Typography)(({theme}) => ({
  color: theme.palette.text.primary,
  fontWeight: '400',
  fontSize: '.875rem',
  lineHeight: '1.25rem',
}));

export const TypographyHeader = styled(Typography)(({theme}) => ({
  color: theme.palette.common.black,
  fontWeight: '700',
  fontSize: '1.25rem',
  lineHeight: '1.5rem',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}));
